import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { apiFetch, readApiJson } from '../lib/api';
import { getDefaultPortalPath } from '../lib/portalAccess';

export default function AuthCallbackPage() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => { document.title = 'Connexion'; }, []);

  useEffect(() => {
    let active = true;

    async function finalizeMicrosoftLogin() {
      const params = new URLSearchParams(location.search);
      const incomingError = params.get('error');
      if (incomingError) {
        navigate(`/login?error=${encodeURIComponent(incomingError)}`, { replace: true });
        return;
      }

      // Hôte standalone (bi, rc) : le SSO s'est joué sur le portail, dont le
      // cookie de session ne vaut que pour LUI. Ce jeton, à usage unique et de
      // durée très courte, ouvre la session ICI. Sans lui, `refresh()` ne
      // trouverait rien et la page repartirait au login en boucle.
      const handoff = params.get('handoff');
      if (handoff) {
        let raison = '';
        try {
          const response = await apiFetch('/api/auth/handoff/exchange', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: handoff }),
          });
          const payload = await readApiJson(response);
          if (!response.ok || !payload.ok) {
            raison = payload.message || payload.error || 'Connexion impossible';
          }
        } catch (err) {
          raison = err.message || 'Connexion impossible';
        }
        if (!active) return;
        if (raison) {
          navigate(`/login?error=${encodeURIComponent(raison)}`, { replace: true });
          return;
        }
      }

      const user = await refresh();
      if (!active) return;

      if (user) {
        const isBiHost = typeof window !== 'undefined' && window.location.hostname === 'bi.meteris.fr';
        const isRcHost = typeof window !== 'undefined' && window.location.hostname === 'rc.meteris.fr';
        let returnTo = null;
        try { returnTo = sessionStorage.getItem('returnTo'); sessionStorage.removeItem('returnTo'); } catch {}
        navigate(isBiHost ? '/bi' : isRcHost ? '/reception' : (returnTo || getDefaultPortalPath(user)), { replace: true });
        return;
      }

      navigate('/login?error=Session Microsoft introuvable', { replace: true });
    }

    finalizeMicrosoftLogin();
    return () => {
      active = false;
    };
  }, [location.search, navigate, refresh]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0B0C10',
      color: '#fff',
      fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
      padding: 24,
      textAlign: 'center',
    }}>
      <div>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 10 }}>Connexion en cours</div>
        <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13 }}>
          Finalisation de la session du portail...
        </div>
      </div>
    </div>
  );
}
